import { GET_DOCS_FAILED, GET_DOCS_SUCCESSED } from "../actions/types";
const initialState = {
	docs: {},
	Onedocs: {},
	isDone: false,
	isFailed: false,
};
export default function (state = initialState, action) {
	switch (action.type) {
		case GET_DOCS_SUCCESSED:
			return {
				docs: action.payload,

				isDone: true,
				isFailed: false,
			};
		case GET_DOCS_FAILED:
			return {
				isDone: true,
				isFailed: false,
			};

		default:
			return state;
	}
}
